import { useState } from "react";
import { Plus, X, RotateCcw } from "lucide-react";

// Editable list of names (banks / PFAs). Empty `items` means "use the official list".
export const ReferenceListEditor = ({ title, hint, items, official, onChange, testid, emptyLabel = "official list", resetLabel = "Reset to official list" }) => {
    const [draft, setDraft] = useState("");
    const list = items?.length ? items : official;
    const custom = !!items?.length;

    const add = () => {
        const name = draft.trim().replace(/\s+/g, " ");
        if (!name || list.some((x) => x.toLowerCase() === name.toLowerCase())) { setDraft(""); return; }
        onChange([...list, name].sort((a, b) => a.localeCompare(b)));
        setDraft("");
    };
    const remove = (name) => onChange(list.filter((x) => x !== name));

    return (
        <div data-testid={testid}>
            <div className="flex items-end justify-between gap-3 flex-wrap">
                <div>
                    <h3 className="font-display font-bold text-base text-ink">{title}</h3>
                    <p className="text-xs text-ink/50 mt-1">
                        {hint} · {list.length} entries · {custom ? "customised" : emptyLabel}
                    </p>
                </div>
                {custom && (
                    <button
                        type="button"
                        onClick={() => onChange([])}
                        className="inline-flex items-center gap-1.5 text-xs text-klein hover:text-ink"
                        data-testid={`${testid}-reset`}
                    >
                        <RotateCcw className="w-3.5 h-3.5" /> {resetLabel}
                    </button>
                )}
            </div>
            <div className="mt-3 flex gap-2">
                <input
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
                    placeholder="Add a name…"
                    className="flex-1 border border-ink/15 py-2 px-3 text-sm focus:border-klein focus:outline-none"
                    data-testid={`${testid}-input`}
                />
                <button
                    type="button"
                    onClick={add}
                    className="inline-flex items-center gap-1 bg-klein text-white px-4 text-sm hover:bg-klein/90"
                    data-testid={`${testid}-add`}
                >
                    <Plus className="w-4 h-4" /> Add
                </button>
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5 max-h-56 overflow-y-auto">
                {list.map((name) => (
                    <span key={name} className="inline-flex items-center gap-1 border border-ink/15 bg-bone/50 pl-2.5 pr-1 py-1 text-xs text-ink">
                        {name}
                        <button
                            type="button"
                            onClick={() => remove(name)}
                            className="p-0.5 text-ink/40 hover:text-red-600"
                            title={`Remove ${name}`}
                            data-testid={`${testid}-remove-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        >
                            <X className="w-3 h-3" />
                        </button>
                    </span>
                ))}
            </div>
        </div>
    );
};
